'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

/**
 * Prefetch critical navigation paths on idle.
 * Uses requestIdleCallback to avoid blocking main thread.
 * Prefetches the most common user journeys:
 * 1. Homepage → medications
 * 2. Homepage → for-pharmacies
 * 3. Drug page → upload prescription
 */
export function PrefetchLinks() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    
    const prefetchPaths = [
      '/medications',
      '/for-pharmacies',
      '/pricing',
      '/how-it-works',
      '/support',
    ];

    const prefetch = () => {
      prefetchPaths.forEach((path) => {
        try {
          router.prefetch(path);
        } catch {
          // Silently fail - prefetch is a hint, not critical
        }
      });
    };

    // Use requestIdleCallback if available, otherwise setTimeout
    if ('requestIdleCallback' in window) {
      (window as unknown as { requestIdleCallback: (cb: () => void) => void }).requestIdleCallback(prefetch);
    } else {
      setTimeout(prefetch, 2000);
    }
  }, [router]);

  return null;
}
